<template>
  <div v-html='hyphenation' />
</template>


<script setup>
  const props = defineProps(['html']);
  const language = document.documentElement.lang;
  import { hyphenateHTML as hyphenateEnglishHTML } from "hyphen/en";
  const hyphenation = ref(null);
  const cleanSoftHyphens = function(text){
    const words = text.split(/\s+/);
    const replacement = '';
    const processedWords = words.map(word => {
      const regex = /&shy;(?=.{0,4}\b)/;
      const reverseregex = /;yhs&(?=.{0,4}\b)/;
      const newword = word.replace(regex, replacement);
      const reversed = newword.split('').reverse().join('')
      const newreversed = reversed.replace(reverseregex, replacement).split('').reverse().join('');
      //console.log(word);
      return newreversed;
    });
    const result = processedWords.join(' ');
    return result;
  }
  onMounted(() => {
    hyphenateEnglishHTML( props.html, { debug: false, hyphenChar: "&shy;", minWordLength: 10 } ).then(result => {
      hyphenation.value = cleanSoftHyphens(result);
    });
  });
</script>

<style scoped>
  span {
    hyphens: manual;
  }
</style>
